import { Injectable } from '@angular/core';

declare var window: any;


@Injectable({
    providedIn: 'root'
})
export class MetadataService {
  isXDespShowInfoEnabled(): boolean {
    return typeof window !== 'undefined' && window.xDespShowInfo
  }
}